import React, { useState, useEffect } from 'react';
import supabase from '../../utils/supabaseClient';
import PostPitchDeckForm from './PostPitchDeckForm';

/**
 * PostPitchDeckButton component - Button to post a pitch deck to the gallery with modal form
 */
const PostPitchDeckButton = ({ pitchDeck }) => {
  const [isAlreadyPosted, setIsAlreadyPosted] = useState(false);
  const [isPostModalOpen, setIsPostModalOpen] = useState(false);
  
  useEffect(() => {
    // Check if pitch deck is already posted to gallery
    const checkIfPosted = async () => {
      if (pitchDeck && pitchDeck.id) {
        try {
          const { data, error } = await supabase
            .from('gallery_pitches')
            .select('id')
            .eq('pitch_deck_id', pitchDeck.id)
            .limit(1);
            
          if (!error && data && data.length > 0) {
            setIsAlreadyPosted(true);
          } else {
            setIsAlreadyPosted(false);
          }
        } catch (error) {
          console.error('Error checking if pitch is posted:', error);
        }
      }
    };
    
    checkIfPosted();
  }, [pitchDeck]);
  
  const handlePostToGallery = () => {
    setIsPostModalOpen(true);
  };
  
  const handlePostSuccess = () => {
    setIsAlreadyPosted(true);
    setIsPostModalOpen(false);
  };
  
  // Post to Gallery Modal
  const PostGalleryModal = () => {
    if (!isPostModalOpen) return null;
    
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto">
          <PostPitchDeckForm 
            pitchDeck={pitchDeck} 
            onClose={() => setIsPostModalOpen(false)} 
            onSuccess={handlePostSuccess}
          />
        </div>
      </div>
    );
  };
  
  return (
    <>
      {!isAlreadyPosted ? (
        <button
          onClick={handlePostToGallery}
          className="flex items-center px-4 py-2 bg-green-50 text-green-600 rounded hover:bg-green-100"
        >
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
          </svg>
          Post to Gallery
        </button>
      ) : (
        <div className="flex items-center px-4 py-2 bg-gray-100 text-gray-600 rounded">
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
          Already Posted
        </div>
      )}
      
      <PostGalleryModal />
    </>
  );
};

export default PostPitchDeckButton; 